import { REGISTER_FORM_RECEIVE } from '../constants';

const DEFAULT_STATE = {
  isLoading: false,
  currencies: [],
  numberOfAccounts: [],
  companyTypes: [],
  salesPicker: [],
  registerSuccessMessage: undefined,
  countryCode: undefined,
};

export const registerOptions = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case REGISTER_FORM_RECEIVE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
